import React, { createContext, useContext, useEffect, useState } from "react";
import { langDiv } from "../lang/useLang";
const ContextOpen = createContext({});

const ContextProvider = ({ children }) => {
  const [swiperIndex, setSwiperIndex] = useState("");
  const [direction, setDirection] = useState("");
  const [translate, setTranslate] = useState(
    window.localStorage.getItem("language")
  );
  const [showPopUp, setShowPopUp] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (window.localStorage.getItem("language") === "ar" || langDiv === "ar") {
      setDirection("rtl");
    }
    if (window.localStorage.getItem("language") === "en") {
      setDirection("ltr");
    }
  }, [translate]);

  const changeLanguage = () => {
    setTranslate("ar");
    window.location.reload();
    window.localStorage.setItem("language", "ar");
  };
  const changeLanguage2 = () => {
    setTranslate("en");
    window.location.reload();
    window.localStorage.setItem("language", "en");
  };

  return (
    <ContextOpen.Provider
      value={{
        showPopUp,
        setShowPopUp,
        changeLanguage,
        changeLanguage2,
        swiperIndex,
        setSwiperIndex,
        successMessage,
        setSuccessMessage,
        direction,
      }}
    >
      {children}
    </ContextOpen.Provider>
  );
};

export default ContextProvider;

export const useContextHook = () => {
  return useContext(ContextOpen);
};
